import { AdminApi, agentIdentifier } from "@/api";
import { EmptyState } from "@/components/ui";
import type { AgentState, SkillCatalog } from "@/types";
import { AgentEditor } from "./AgentEditor";

export function AgentsPage({
  api,
  agent,
  skillCatalog,
  saving,
  setSaving,
  onSaved,
  onError,
  onFlash,
}: {
  api: AdminApi;
  agent?: AgentState;
  skillCatalog: SkillCatalog | null;
  saving: boolean;
  setSaving: (value: boolean) => void;
  onSaved: (agent: AgentState) => void;
  onError: (error: unknown) => void;
  onFlash?: (message: string) => void;
}) {
  if (!agent) {
    return <EmptyState title="No agent selected" body="Load agents and select one from the left." />;
  }
  return (
    <AgentEditor
      // Load-bearing: AgentEditor's form state is one-shot useState initialized
      // from `agent`. This remount is what resets the form when the selection
      // changes. Saving keeps the same identifier, so in-progress edits in other
      // sections survive a save — that is intentional.
      key={agentIdentifier(agent)}
      api={api}
      agent={agent}
      skillCatalog={skillCatalog}
      saving={saving}
      setSaving={setSaving}
      onSaved={onSaved}
      onError={onError}
      onFlash={onFlash}
    />
  );
}
